/**
 * Create Domain Handler
 * 
 * CQRS Command Handler that delegates to DomainCommandService.
 * Thin adapter layer that transforms commands to application service calls.
 * 
 * FIXED: No more Inversify - direct constructor injection following party-manager pattern.
 */

import { ICommandHandler } from '@swoft/core';
import { CreateDomainCommand } from '../commands/CreateDomainCommand';
import { DomainCommandService } from '../services/DomainCommandService';

export class CreateDomainHandler implements ICommandHandler<CreateDomainCommand, { domainId: string }> {
  constructor(
    private readonly domainCommandService: DomainCommandService
  ) {}

  async handle(command: CreateDomainCommand): Promise<{ domainId: string }> {
    const result = await this.domainCommandService.createDomain(
      command.payload,
      command.authSessionId,
      command.initiatedByPersonId,
      command.correlationId
    );
    
    return { 
      domainId: result.domainId 
    };
  }
}